<template>
<div class="swiper-slide-inner">
    <div class="step">
        <p>STEP<span>07</span></p>
    </div>
    <div class="card">
        <div class="card-inner">

            <div class="question-wrap">
                <h3><span>ネット通販サイトのURL設定</span></h3>
                <p><span>ネット通販サイトがあればURLを登録してください。無い場合は未記入のまま次にお進みください。</span></p>
            </div>

            <!--item-->
            <div class="item-wrap">
                <div class="item form_text">
                    <input type="url" id="your-webshop-url" placeholder=" " value="">
                    <label for="your-webshop-url" class="m-label"><span>URL</span></label>
                </div>
            </div>
        </div>

        <div class="control-wrap">
            <button type="button" class="_left js-swiper-prev"><span>Back</span></button>
            <button type="button" class="_right js-swiper-next"><span>Next</span></button>
        </div>

    </div>
</div>
</template>

